module.exports = __webpack_public_path__ + "img/transferen02.989fd877.jpg";